<template>
    <transition
        enter-active-class="transition-all duration-300 ease-out"
        enter-from-class="max-h-0 opacity-0"
        enter-to-class="max-h-24 opacity-100"
        leave-active-class="transition-all duration-200 ease-in"
        leave-from-class="max-h-24 opacity-100"
        leave-to-class="max-h-0 opacity-0"
    >
        <c-alert v-if="topMessageContent && !dismissed" color="success" class="mt-3 mb-0 flex items-center justify-between gap-4 sm:-mx-3">
            <div class="flex-1">
                <render-flash-node :node="topMessageContent" />
            </div>
            <button type="button" class="btn btn-icon text-success-emphasis shrink-0" aria-label="Dismiss notification" @click="dismissed = true">
                <icon name="cil-x-circle" />
            </button>
        </c-alert>
    </transition>
</template>

<script setup>
import { computed, ref, watch } from 'vue';
import { usePage } from '@inertiajs/vue3';
import { parseLinksFromString, renderNode } from '@/Utils/flashContent.ts';
import { CAlert } from '@coreui/vue-pro/dist/esm/components/alert/index.js';

const page = usePage();

function RenderFlashNode(props) {
    return renderNode(props.node);
}

RenderFlashNode.props = {
    node: {
        type: [String, Number, Object, Array],
        default: null,
    },
};

const dismissed = ref(false);

const topMessageContent = computed(() => {
    const message = page.props.flash?.topMessage;
    if (!message) {
        return null;
    }
    const parsed = parseLinksFromString(message);
    return parsed ?? message;
});

watch(
    () => page.props.flash?.topMessage,
    (newVal, oldVal) => {
        if (newVal && newVal !== oldVal) {
            dismissed.value = false;
        }
    },
);
</script>
